export default {
  props: {
    provider: {
      type: Object,
      default: () => ({}),
    },
  },
};
